import { getOr, get, pick } from "lodash/fp";
import moment from "moment-timezone";
import { regex } from "@teamrota/rota-common";

import { isValidDate } from "~/src/utils/validators";

import { Role } from "@teamrota/authlib";

export const getFields = (auth, isSave = false) => {
  const fields = [
    "notes",
    "internalId",
    "ownerId",
    "isEligibleForRebook",
    "isEligibleForAvailability",
    "isEligibleForCandidatePreferences"
  ];

  if (
    (isSave && auth.hasRole(Role.MEMBERS_STATE_EDIT)) ||
    (!isSave && auth.hasRole(Role.MEMBERS_STATE))
  ) {
    fields.push(...["state"]);
  }

  return fields;
};

const getDefaultValues = auth =>
  Object.fromEntries(getFields(auth).map(val => [val, null]));

export const getValuesFromProps = (auth, props) => ({
  ...getDefaultValues(auth),
  ...pick(getFields(auth, false))(props.member),
  serviceAreas: getOr([], "member.serviceAreas", props).map(area => area.id),
  ownerId: get("member.ownerId", props) || auth.info.id
});

export const getValuesToSave = (auth, values) => ({
  ...pick(getFields(auth, true))(values),
  serviceAreas: values.serviceAreas
});

export const validate = values =>
  Object.keys(values).reduce((acc, current) => {
    let error = "";
    if (current === "birthDate") {
      if (!isValidDate(values.birthDate)) {
        error = "Please enter a valid date DD/MM/YYYY";
      } else if (
        moment(values.birthDate, "DD/MM/YYYY").isBefore(
          moment("01/01/1930", "DD/MM/YYYY")
        ) ||
        moment().isBefore(moment(values.birthDate, "DD/MM/YYYY"))
      ) {
        error = "Please enter a valid birth date";
      }
    }

    if (current === "startDate") {
      if (!isValidDate(values.startDate)) {
        error = "Please enter a valid date DD/MM/YYYY";
      }
    }

    if (current === "endDate") {
      if (!isValidDate(values.endDate)) {
        error = "Please enter a valid date DD/MM/YYYY";
      }
    }

    if (current === "sortCode") {
      if (!!values.sortCode && !/^\d{6}$/.test(values.sortCode)) {
        error = "Please enter a 6 digit bank sort code";
      }
    }

    if (current === "accountNumber") {
      if (!!values.accountNumber && !/^\d{8}$/.test(values.accountNumber)) {
        error = "Please enter an 8 digit bank account number";
      }
    }

    if (current === "email") {
      if (!regex.EMAIL_ADDRESS.test(values.email)) {
        error = "Please enter a valid email";
      }
    }
    return {
      ...acc,
      [current]: error
    };
  }, {});
